import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../../firebase/config';
import { PaperclipIcon } from '../../../components/icons/Icons';

// This is the dedicated, reusable modal for viewing request/invoice details.
export default function ApprovalDetailModal({ item, onClose, appId }) {
    const [approverName, setApproverName] = useState('');
    const isPurchase = item.type === 'Purchase';

    useEffect(() => {
        const fetchApproverName = async () => {
            // This field exists on both Purchases and Invoices
            const approverId = item.assignedApproverId; 
            
            if (approverId) {
                const userDocRef = doc(db, `/artifacts/${appId}/users/${approverId}`);
                const userDocSnap = await getDoc(userDocRef);
                if (userDocSnap.exists()) {
                    setApproverName(userDocSnap.data().name);
                } else {
                    setApproverName('Approver not found');
                }
            } else {
                setApproverName('N/A');
            }
        };

        // Run this logic for both item types
        fetchApproverName();

    }, [item, appId]);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-2xl max-h-full overflow-y-auto">
                <h2 className="text-2xl font-semibold text-[#213368] mb-4">Request Details</h2>
                <div className="space-y-4 text-sm">
                    <p><strong>Type:</strong> {item.type}</p>
                    <p><strong>ID:</strong> {item.invoiceNumber || item.requestNumber}</p>
                    <p><strong>Date Submitted:</strong> {item.createdAt?.toDate().toLocaleDateString()}</p>
                    <p><strong>Requester:</strong> {item.requesterName || item.submittedBy}</p>
                    {isPurchase && <p><strong>Department:</strong> {item.department}</p>}
                    
                    <p><strong>Approver:</strong> {approverName || 'Loading...'}</p>
                    
                    <p><strong>Vendor:</strong> {item.vendorName || (isPurchase ? (item.vendorType === 'new' ? item.newVendorName : item.selectedVendor) : 'N/A')}</p>
                    <p><strong>Amount:</strong> {item.currency} {item.approxValue || item.amount}</p>
                    
                    {item.type === 'Invoice' && <p><strong>Due Date:</strong> {item.dueDate?.toDate().toLocaleDateString()}</p>}
                    
                    {isPurchase ? (
                        <p><strong>Description:</strong> {item.description}</p>
                    ) : (
                        <p><strong>Submitter's Comments:</strong> {item.comments || 'No comments provided.'}</p>
                    )}
                    
                    {isPurchase && <p><strong>Engagement:</strong> {item.engagementStartDate.toDate().toLocaleDateString()} - {item.engagementEndDate.toDate().toLocaleDateString()}</p>}
                    
                    <div className="pt-2">
                        <p className="font-medium">Attachments:</p>
                        <ul className="list-disc list-inside mt-1">
                            {isPurchase ? 
                                // Logic for Purchase Request attachments (can be multiple)
                                (item.fileAttachments && item.fileAttachments.length > 0 ? (
                                    item.fileAttachments.map((file, i) => (
                                        <li key={i}><a href={file.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline flex items-center gap-1"><PaperclipIcon /> {file.name}</a></li>
                                    ))
                                ) : <li>No files attached</li>)
                                :
                                // Logic for Invoice attachment (is a single object)
                                (item.invoiceFile?.url ? 
                                    <li><a href={item.invoiceFile.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline flex items-center gap-1"><PaperclipIcon /> {item.invoiceFile.name}</a></li> : 
                                    <li>No file attached</li>)
                            }
                        </ul>
                    </div>
                </div>
                <div className="flex justify-end space-x-4 pt-6 mt-4 border-t">
                    <button onClick={onClose} className="px-6 py-2 bg-gray-200 text-gray-700 font-medium rounded-lg hover:bg-gray-300">Close</button>
                </div>
            </div>
        </div>
    );
}